import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, watch } from "vue";
import FindPropertyModal from "./find-property-modal.vue";
import { PropertyFindResult } from "@/types/find/properties/PropertyFindResult";
import { useRouter } from "vue-router";
import { RouteNames } from "@/router/RouteNames";
import { usePropertyRecordNavigationStore } from "@/stores/record-navigation/PropertyRecordNavigationStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-property',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const router = useRouter();
const recordNavigationStore = usePropertyRecordNavigationStore();

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue) {
      clearRecordNavigationCache();
    }
  },
);

/** Clear previous cached record navigation to avoid wrong properties appearing when user scrolls between records */
const clearRecordNavigationCache = () => recordNavigationStore.clear();

/** Loads the selected property */
const onPropertySelected = (
  property: PropertyFindResult,
  propertyIds: number[],
  rowIndex: number,
) => {
  if (!property?.id) {
    return;
  }

  // Cache results so user can scroll between them
  recordNavigationStore.cacheProperties(propertyIds, rowIndex);

  router.push({
    name: RouteNames.PropertyPage,
    params: { propertyid: property.id.toString() },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FindPropertyModal, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    onPropertySelected: onPropertySelected
  }, null, 8, ["modelValue"]))
}
}

})